import { ColumnConfig, ColumnDataType } from '@aurora';

export const fleetAircraftColumnsConfig: ColumnConfig[] = [
    {
        type: ColumnDataType.STRING,
        field: 'plate',
        sort: 'plate',
        translation: 'digitai.Plate',
        isUnaccent: true,
    },
    {
        type: ColumnDataType.STRING,
        searchableField: '$DigitaiFleetAircraft.serialNumber$',
        field: 'serialNumber',
        sort: 'serialNumber',
        translation: 'digitai.AircraftSerialNumber',
        isUnaccent: true,
    },
    {
        type: ColumnDataType.STRING,
        field: 'status.name',
        searchableField: '$status.name$',
        sort: 'status.name',
        translation: 'Status',
        isUnaccent: true,
    },
    {
        type: ColumnDataType.STRING,
        field: 'engine1SerialNumber',
        sort: 'engine1SerialNumber',
        translation: 'digitai.Engine1SerialNumber',
    },
    {
        type: ColumnDataType.STRING,
        field: 'engine2SerialNumber',
        sort: 'engine2SerialNumber',
        translation: 'digitai.Engine2SerialNumber',
    },
    {
        type: ColumnDataType.STRING,
        field: 'engine3SerialNumber',
        sort: 'engine3SerialNumber',
        translation: 'digitai.Engine3SerialNumber',
    },
    {
        type: ColumnDataType.STRING,
        field: 'engine4SerialNumber',
        sort: 'engine4SerialNumber',
        translation: 'digitai.Engine4SerialNumber',
    },
];

export const fleetAircraftDashboardColumnsConfig: (nMotors: number) => ColumnConfig[] = (nMotors = 4) =>
{

    const columnConfig: ColumnConfig[] = [
        {
            type: ColumnDataType.STRING,
            field: 'plate',
            sort: 'plate',
            translation: 'digitai.Plate',
            isUnaccent: true,
        },
        {
            type: ColumnDataType.STRING,
            searchableField: '$DigitaiFleetAircraft.serialNumber$',
            field: 'serialNumber',
            sort: 'serialNumber',
            translation: 'digitai.AircraftSerialNumber',
            isUnaccent: true,
        },
        {
            type: ColumnDataType.STRING,
            field: 'status.name',
            searchableField: '$status.name$',
            sort: 'status.name',
            translation: 'Status',
            isUnaccent: true,
        },
    ];

    for (let i = 1; i <= nMotors; i++)
    {
        columnConfig.push(
            {
                type: ColumnDataType.STRING,
                field: `engine${i}SerialNumber`,
                sort: `engine${i}SerialNumber`,
                translation: `digitai.Engine${i}`,
            },
        );
        columnConfig.push(
            {
                type: ColumnDataType.NUMBER,
                field: `engine${i}.engineFlyingHours`,
                sort: `engine${i}.engineFlyingHours`,
                translation: `digitai.Engine${i}FlyingHours`,
            },
        );
    }

    return columnConfig;
};
